'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _Slider = require('../components/Slider');var _Slider2 = _interopRequireDefault(_Slider);
var _checkRtlLanguage = require('../../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _SliderCart = require('./SliderCart.scss');var styles = _interopRequireWildcard(_SliderCart);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

SliderCart = function (_Component) {_inherits(SliderCart, _Component);function SliderCart() {var _temp, _this, _ret;_classCallCheck(this, SliderCart);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    setSliderRef = function (ref) {
      _this.swiperRef = ref;
      _this.swiperRef && _this.swiperRef.swiper && _this.swiperRef.swiper.update();
    }, _this.

    slidePrev = function () {var
      isRtl = _this.props.isRtl;

      if (_this.swiperRef && isRtl) {_this.swiperRef.swiper.slideNext();}
      if (_this.swiperRef && !isRtl) {_this.swiperRef.swiper.slidePrev();}
    }, _this.

    slideNext = function () {var
      isRtl = _this.props.isRtl;

      if (_this.swiperRef && isRtl) {_this.swiperRef.swiper.slidePrev();}
      if (_this.swiperRef && !isRtl) {_this.swiperRef.swiper.slideNext();}
    }, _temp), _possibleConstructorReturn(_this, _ret);}SliderCart.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,children = _props.children,screenWidth = _props.screenWidth,title = _props.title,_props$isShowNavigati = _props.isShowNavigation,isShowNavigation = _props$isShowNavigati === undefined ? true : _props$isShowNavigati;
    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        _react2.default.createElement('div', { className: styles.topBlock },
          _react2.default.createElement('p', { className: styles.title }, title),
          isShowNavigation && _react2.default.createElement('div', { className: styles.navigationWrapper },
            _react2.default.createElement('button', { className: styles.slidePrev, onClick: this.slidePrev },
              _react2.default.createElement('i', { className: 'icon icon-back' })),

            _react2.default.createElement('button', { className: styles.slideNext, onClick: this.slideNext },
              _react2.default.createElement('i', { className: 'icon icon-next-arrow' })))),



        _react2.default.createElement('div', { className: styles.sliderWrapper },
          _react2.default.createElement(_Slider2.default, {
              innerRef: function innerRef(ref) {_this2.swiperRef = ref;},
              initialSlide: 0,
              screenWidth: screenWidth,
              noSwiping: !isShowNavigation },

            children))));




  };return SliderCart;}(_react.Component);


SliderCart.propTypes = {
  title: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  children: _propTypes2.default.node,
  screenWidth: _propTypes2.default.number,
  isShowNavigation: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    screenWidth: state.windowDimentions.width,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale) };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
SliderCart);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/SliderCart/SliderCart.js
// module id = 1215
// module chunks = 0